import { isUndefinedOrNullOrEmpty } from '@/utilities';
import EasyPassClient from './EasyPassClient';

class UserClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.apiVersion = '';
    this.rootUri = '';
    this.easyPassRootUri = 'api/acvapi/v3';
    this.easyPassHeaders = {
      'json-naming-strategy': 'camel',
    };
    this.user = user;
  }

  logout(refreshToken) {
    if (
      isUndefinedOrNullOrEmpty(this.user)
      || isUndefinedOrNullOrEmpty(refreshToken)
    ) {
      throw new Error('missing required parameters for logout');
    }
    const params = {
      userId: this.user.id,
      refreshToken,
    };
    return this.easyPassClient.post('bff/identity/user/logout', params, this.easyPassHeaders);
  }

  getUserSettings(category = false, key = false) {
    const params = {};

    if (category) {
      params.category = category;
    }
    if (key) {
      params.setting_key = key;
    }

    return this.easyPassClient
      .get('bff/settings', params, this.easyPassHeaders);
  }

  getSmsSettings() {
    const params = {};
    return this.easyPassClient.get('bff/settings/sms', params, this.easyPassHeaders);
  }

  saveUserSetting(key, value, settingsValueKey = 'setting_value') {
    const data = {
      setting_key: key,
      [settingsValueKey]: value,
    };
    return this.easyPassClient.put('bff/settings', data, {
      'json-naming-strategy': 'snake',
    });
  }

  saveUserMultiSelectSetting(key, value) {
    return this.saveUserSetting(key, value, 'setting_values');
  }

  saveSmsSettings(data = {}) {
    return this.easyPassClient.put('bff/settings/sms', data, {
      'json-naming-strategy': 'snake',
    });
  }

  getUser(userId, includeDealerships = true, includeInactiveDealerships = false, isSnake = false) {
    let headers = { ...this.easyPassHeaders };
    if (isSnake) {
      headers = {
        ...headers,
        'json-naming-strategy': 'snake',
      };
    }
    return this.easyPassClient
      .get(
        `${this.easyPassRootUri}/user/${userId}`,
        {
          include_dealerships: includeDealerships,
          include_inactive_dealerships: includeInactiveDealerships,
        },
        headers,
      );
  }

  getUserFromAcvApi(userId, params) {
    return this.easyPassClient
      .get(`${this.easyPassRootUri}/user/${userId}`, {
        ...params,
      });
  }

  getUserLoginData() {
    return this.easyPassClient.get(`${this.easyPassRootUri}/user/login_data`, { web: true });
  }

  putKeyValueStoreItem(key, value) {
    return this.easyPassClient.post('query-engine/user/key_value', { [key]: value });
  }

  getKeyValueStoreItem(keys) {
    return this.easyPassClient.get('query-engine/user/key_value', { keys });
  }

  updateUser(user) {
    return this.easyPassClient
      .patch('bff/user', user, {
        'json-naming-strategy': 'snake',
      });
  }

  getCreditBalanceInfo() {
    return this.easyPassClient.get('api/acvapi/v2/credits/balance');
  }

  getCobrandingData(params) {
    return this.easyPassClient.get('/api/acvapi/v1/myacv/dealership/logo', params);
  }
}

export default UserClient;
